import IModel from "./IModel";

export default class Location implements IModel<Location> {
	id?: string | null;
	name?: string | null;
	fullName?: string | null;
	country?: string | null;
	lat?: number | null;
	long?: number | null;
	image?: string | null;
	partnerCount?: number | null;
	url?: string;
	partnerIds?: number[] | null;
	reviewCount?: number;
	review?: number;

	constructor(input?: Partial<Location>) {
		this.id = input?.id;
		this.name = input?.name;
		this.fullName = input?.fullName;
		this.country = input?.country;
		this.lat = input?.lat;
		this.long = input?.long;
		this.image = input?.image;
		this.partnerCount = input?.partnerCount;
		this.url = input?.url;
		this.partnerIds = input?.partnerIds;
		this.reviewCount = input?.reviewCount;
		this.review = input?.review;
	}

	parse(json?: any): Location {
		if (!json) return this;

		Object.assign(this, {
			...json,
			id: json.id,
			name: json.name,
			fullName: json.fullName,
			country: json.country,
			lat: json.lat,
			long: json.long,
			image: json.image,
			partnerCount: json.partnerCount,
			url: json.url,
			partnerIds: json.partnerIds,
			reviewCount: json.reviewCount,
			review: json.review,
		});

		return this;
	}
	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new Location().parse(item));
	}
	clone(): Location {
		return new Location({
			...this,
		});
	}
}

export class SearchLocation implements IModel<SearchLocation> {
	placeId?: string | null;
	description?: string | null;
	text?: Text | null;

	constructor(input?: Partial<SearchLocation>) {
		this.placeId = input?.placeId;
		this.description = input?.description;
		this.text = input?.text;
	}

	parse(json?: any): SearchLocation {
		if (!json) return this;

		Object.assign(this, {
			...json,
			placeId: json.placeId,
			description: json.description,
			text: json.text,
		});

		return this;
	}
	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new SearchLocation().parse(item));
	}
	clone(): SearchLocation {
		return new SearchLocation({
			...this,
		});
	}
}

export class Text implements IModel<Text> {
	mainText?: string | null;
	secondaryText?: string | null;

	constructor(input?: Partial<Text>) {
		this.mainText = input?.mainText;
		this.secondaryText = input?.secondaryText;
	}

	parse(json?: any): Text {
		if (!json) return this;

		Object.assign(this, {
			...json,
			mainText: json.mainText,
			secondaryText: json.secondaryText,
		});

		return this;
	}
	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new Text().parse(item));
	}
	clone(): Text {
		return new Text({
			...this,
		});
	}
}

export class LocationDetail implements IModel<LocationDetail> {
	id?: string | null;
	address?: string | null;
	geometry?: Geometry | null;
	icon?: string | null;
	url?: string | null;

	constructor(input?: Partial<LocationDetail>) {
		this.id = input?.id;
		this.address = input?.address;
		this.geometry = input?.geometry;
		this.icon = input?.icon;
		this.url = input?.url;
	}

	parse(json?: any): LocationDetail {
		if (!json) return this;

		Object.assign(this, {
			...json,
			id: json.id,
			address: json.address,
			geometry: json.geometry,
			icon: json.icon,
			url: json.url,
		});

		return this;
	}
	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new LocationDetail().parse(item));
	}
	clone(): LocationDetail {
		return new LocationDetail({
			...this,
		});
	}
}

export class Geometry implements IModel<Geometry> {
	lat?: string | null;
	long?: string | null;

	constructor(input?: Partial<Geometry>) {
		this.lat = input?.lat;
		this.long = input?.long;
	}

	parse(json?: any): Geometry {
		if (!json) return this;

		Object.assign(this, {
			...json,
			lat: json.lat,
			long: json.long,
		});

		return this;
	}
	parseList(jsons: any) {
		if (!jsons || !jsons.length) return;

		return jsons.map((item: any) => new Geometry().parse(item));
	}
	clone(): Geometry {
		return new Geometry({
			...this,
		});
	}
}
